import defaultTheme from './default';
import flashscoreTheme from './flashscore';
import foxThemeLight from './fox';
import foxThemeDark from './fox-dark';
import theSportingNewsTheme from './the-sporting-news';
import joeTheme from './joe';

const themes: Record<string, string> = {
  fox: foxThemeLight,
  'fox-dark': foxThemeDark,
  flashscore: flashscoreTheme,
  'the-sporting-news': theSportingNewsTheme,
  joe: joeTheme
};

export default function (theme?: string): string {
  return (theme && themes[theme]) ?? defaultTheme;
}
